import styled from 'styled-components';

const DivWrap = styled.div`
  padding: .5rem 0;
	align-items: center;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	gap: .25rem;

	&.roof-attr-wrap{
		padding: 0.15rem 0;
		@media (min-width: 936px){
			width: 100%;
			justify-content: space-between;
			padding: 0.15rem;
		}
	}
`;

const DivLabel = styled.div`
	    display: flex;
    	align-items: center;
    	gap: 2px;
			color: var(--textColor);
			font-family: Inter;
			font-size: 14px;
			font-weight: 600;
			margin-bottom: 0;
			line-height: 16px;

			@media (max-width: 1339px){
			//  font-size: 14px;

			 svg { width: 18px; height: 18px}
			}

			&.roof-attr-label{
				font-weight: 500;
				span{
					font-weight: 400;
					font-size: 13px;
				}
				@media (max-width: 935px){
					font-weight: 500;
				}
			}
`;
const DivValue = styled.div`
			display: flex;
    	align-items: center;
    	gap: 5px;
			font-family: Inter;
			color: var(--textColor);
    	font-size: 14px;
			line-height:16px;
    	font-weight: 500;

			@media (max-width: 1339px){

			 svg{ width: 18px; height: 18px}
			}

			&.roof-attr-value{
				color: var(--primary);
				font-size: 14px;
    		font-weight: 600;
			}
`;

const DivInputWithUnit = styled.div<{ $stretch?: boolean }>`
	position: relative;
	display: flex;
	align-items: center;
	flex: 0 1 auto;
	width: auto;

	input {
		width: 120px;
		max-width: 100%;
		padding-right: 2.25rem;
		text-align: left;
	}

	${({ $stretch }) => $stretch && `
		flex: 1 1 auto;
		width: 100%;

		input {
			width: 100%;
		}
	`}

	.unit {
		position: absolute;
		right: .625rem;
		pointer-events: none;
		color: var(--subHeadingColor);
		font-family: Inter;
		font-size: 14px;
		line-height: 16px;
		font-weight: 500;
	}

	&.error input {
		border-color: #ff4d4f;
		background: var(--errorBgColor);
		color: #ff4d4f;
		outline: none;
	}

	&.error input:focus {
		box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2);
	}

	&.error .unit {
		color: #ff4d4f;
	}
`;

const DivAttrDetail = styled.div`
		color: var(--subHeadingColor);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 5px;
		gap:5px;

		label{
			font-size: 14px;
			line-height: 16px;
			font-family: 'Inter';
  		font-weight: 500;
			color: var(--subHeadingColor);
			white-space: nowrap;
			flex: 0 0 auto;
		}
		&.area-sqft-wrap{
			margin-top: 3px;
			margin-bottom: 3px;
			small{
				font-size: 12px;
				opacity: .9;
				font-weight:400;
			}
		}

		&.roof-area-wrap{
      padding-top: 8px;
    }

		span{
			font-size: 14px;
			line-height: 16px;
			font-weight: 600;
			position: relative;
			color: var(--labelValueColor);
		}
			sup{
				opacity:.85;
			}
`;

const DivRowHeight = styled.div`
		color: var(--subHeadingColor);
    display: flex;
    justify-content: center;
	flex-direction: column;
    align-items: flex-start;
    margin-bottom: 5px;
		gap:5px;
		&.single-field-wrap{
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
    width: 100%;
    flex-wrap: wrap;
}

		label{
			font-size: 14px;
			line-height: 16px;
			font-family: 'Inter';
  		font-weight: 500;
			color: var(--subHeadingColor);
			white-space: nowrap;
			flex: 0 0 auto;
		}
		&.area-sqft-wrap{
			margin-top: 3px;
			margin-bottom: 3px;
			small{
				font-size: 12px;
				opacity: .9;
				font-weight:400;
			}
		}

		&.roof-area-wrap{
      padding-top: 8px;
    }

		span{
			font-size: 14px;
			line-height: 16px;
			font-weight: 600;
			position: relative;
			color: var(--labelValueColor);
		}
			sup{
				opacity:.85;
			}

		&.error label{
			color: #ff4d4f;
		}
`;

const DivFieldError = styled.div`
	flex: 1 0 100%;
	margin-top: 4px;
	font-size: 0.75rem;
	color: #ff4d4f;
`;
export {
	DivWrap,
	DivLabel,
	DivValue,
	DivAttrDetail,
	DivInputWithUnit,
	DivRowHeight,
	DivFieldError
};